import React from 'react';
import { MoModal } from '../MoModal';
import SessionNotesContent from '../SessionNotesContent';

type NotesContentProps = React.ComponentProps<typeof SessionNotesContent>;

export type SessionNotesModalProps = {
  open: boolean;
  onClose: () => void;
} & Pick<NotesContentProps, 'legacyNotes' | 'sessionNotesInfo'>;

export function SessionNotesModal({
  open,
  onClose,
  legacyNotes,
  sessionNotesInfo,
}: SessionNotesModalProps) {
  return (
    <MoModal
      open={open}
      onClose={onClose}
      maxWidth="sm"
      title="Session notes"
    >
      <SessionNotesContent legacyNotes={legacyNotes} sessionNotesInfo={sessionNotesInfo} />
    </MoModal>
  );
}
